__turbopack_context__.v({
  "inputWrapper": "CallbackRequestForm-module-scss-module__TQ3SJW__inputWrapper",
  "mainWrapper": "CallbackRequestForm-module-scss-module__TQ3SJW__mainWrapper",
});
